import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { startAnalytics } from "./analytics";
import "./styles.css";

startAnalytics();

const container = document.getElementById("root");
if (container)
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
